.customer-organization-form__company-device-policy-inputs-container {
  width: 360px;
}
